<div
  class="reset-password-form"
  *ngIf="!(accountService.twoFactorAuthRequired | async)">
  <h1
    *ngIf="type == 'reset-password'"
    class="reset-password-form__title">
    {{ ("resetPassword" | i18n) || "reset password" }}
  </h1>
  <h1
    *ngIf="type == 'enroll-account'"
    class="reset-password-form__title">
    {{ ("setPassword" | i18n) || "set password" }}
  </h1>

  <form
    class="reset-password-form__form"
    (ngSubmit)="resetPassword()"
    [formGroup]="form">
    <mat-form-field>
      <mat-label>{{
        ("newPassword" | i18n) || "New password" | titlecase
      }}</mat-label>
      <input
        matInput
        type="password"
        autofocus
        formControlName="password1"
        name="password1"
        data-cy="password-input" />
      <mat-error
        class="input-error"
        *ngIf="form?.controls?.password1?.errors">
        {{
          form?.controls?.password2?.errors?.required
            ? ("requiredField" | i18n) || "Pflichtfeld"
            : form?.controls?.password1?.errors?.minlength
            ? (("passwordIsToShort" | i18n) ||
                "Passwort stimmt nicht überein") +
              " min: " +
              form?.controls?.password1?.errors?.minlength?.requiredLength
            : ""
        }}
      </mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{
        ("repeatPassword" | i18n) || "Repeat password"
      }}</mat-label>
      <input
        matInput
        formControlName="password2"
        type="password"
        name="password2"
        data-cy="confirm-password-input" />
      <mat-error
        class="input-error"
        *ngIf="form?.controls?.password2?.errors">
        {{
          form?.controls?.password2?.errors?.required
            ? ("requiredField" | i18n) || "Pflichtfeld"
            : form?.controls?.password2?.errors?.isNotSame
            ? ("passwordDoesntMatch" | i18n) || "Passwort stimmt nicht überein"
            : ""
        }}
      </mat-error>
    </mat-form-field>

    <button
      mat-button
      color="primary"
      type="submit"
      name="login"
      class="mat-button-block"
      value="Login"
      [disabled]="showLoadingIndicator"
      data-cy="submit-password-button">
      <span>
        <mat-spinner
          *ngIf="showLoadingIndicator"
          diameter="16"
          class="loadingSpinner">
        </mat-spinner>
        {{ ("save" | i18n) || "save" | uppercase }}
      </span>
    </button>
    <div class="reset-password-form__additional-content">
      <a
        mat-button
        class="reset-password-form__back-to-login"
        [routerLink]="['/login']">
        <mat-icon
          class="reset-password-form__back_icon"
          svgIcon="chevron-left"></mat-icon>
        {{ ("goToLogin" | i18n) || "go to login" | uppercase }}
      </a>
    </div>
  </form>
</div>
<app-two-factor-authentication
  [authData]="authData"
  [isPasswordReset]="true"
  *ngIf="
    accountService.twoFactorAuthRequired | async
  "></app-two-factor-authentication>
